import React, { Component } from 'react';
import axios from 'axios'
import * as moment from 'moment';
import { serverIp, getOrderKey, pythonApiIp,whatsapp_api_glassfish } from '../../../../config/constants.js'
import { Button, Image, Form, Divider } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Status from '../../../../config/OrderStatusConstants.js'
import * as UiConsts from '../../../../config/UiConstants'
import ImageUploader from '../../../newSite/ImageUploader'

class WhatsappSendMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: '',
            sendImage: false,
            imageUrl: '',
            message: ''
        }
    }

    componentDidMount() {
        console.log("++++++++++:componentDidMount");


    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //  console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    sendMessage = () => {
        console.log("whtx7 >>>>: sendMessage clicked");
        console.log("whtx71 message:" + this.state.message);

        if(this.state.message == ''){
            alert("Please enter a message to send")
        }else{
            this.setState({ loading: true })

            let actualPhone = "0" + this.props.phone.replace('256','');
            console.log("whtx72 actualPhone:"+actualPhone);

                      // REPLACE_PYTHON_API
            // pythonApiIp
            // whatsapp_api_glassfish
    

            //GET BACK TO FIX
            ////http://localhost:8080/PrintBReporting/webresources/whatsappApi/send_dep_many_orders
          //  axios.post("http://localhost:8080/PrintBReporting/webresources/whatsappApi/" + 'sendGenericMessage', {
            axios.post(whatsapp_api_glassfish + 'sendGenericMessage', {
           // axios.post(serverIp + 'whatsappApi/sendGenericMessage', {
    
                apiKey: 'asdfasdfsf',
                phone: actualPhone,
                message: this.state.message,
                order_num: 12345,
                enteredBy: this.props.user.email,
                imageUrl: this.state.imageUrl
            })
                .then((response) => {
                    console.log("whtx72 message:"+JSON.stringify(response.data,null,3));
    
                    this.setState({ loading: false, 
                        message:'', 
                        imageUrl:'',
                        sendImage:false})
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                    alert("message send failed")
                });
        }

       

    }

    sendImage = () => {
        console.log("+++++ send image +++++");

        if(this.state.sendImage){
            console.log("send image is true making it false")
            this.setState({
                sendImage:false
            })
        }else if(!this.state.sendImage){
            this.setState({
                sendImage:true,
                imageUrl: ''
            })
            console.log("send image is false making it true")
        }
      
    }

    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url,
            sendImage:true
        });
        // this.props.history.push('/newOrder/thankYou');

    }

    render() {

        const imageUrlFeild = this.state.sendImage
            ?  <Form.Input
            fluid
            icon='camera'
            iconPosition='left'
            placeholder= 'Paste Image Url'
            type='text'
            name="imageUrl"
            value={this.state.imageUrl}
            onChange={this.handleTextInputChange}
        />
        :""

        const imagePreview = this.state.imageUrl != ''
        ? (<Image src={this.state.imageUrl} fluid />)
        : (<p></p>)

        const replyUI = this.props.algoliaUser && this.props.algoliaUser.whatsapp_reply
        ? <div>
            <Form onSubmit={this.sendMessage}>
                    <label>{this.props.phone}</label>
                    <Form.Input
                        fluid
                        icon='mail'
                        iconPosition='left'
                        placeholder={this.props.phone}
                        type='text'
                        name="message"
                        value={this.state.message}
                        onChange={this.handleTextInputChange}
                    />
                    {imageUrlFeild}
                    <Button>Send</Button>
                </Form>
                <Button color="blue" onClick={this.sendImage}>USE IMAGE URLS</Button> 
                <Divider> {'UPLOAD AN IMAGE FROM COMPUTER'}</Divider>
                 <ImageUploader
                        updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                        storageReference={'whatsappImages'} />
                    {imagePreview}

                    <Divider> {'image preview above'}</Divider>
                    <br/><br/>
        </div>
        :''

        return (
            this.state.loading === true ? <UiConsts.LoadingComponent /> : <div>
                {replyUI}
            </div>
        )
    }
}

export default WhatsappSendMessage;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappSendMessage.js